/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReportConfigResponse
 */
export interface UpdateReportConfigResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReportConfigResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportConfigResponse
     */
    message: string;
}

/**
 * Check if a given object implements the UpdateReportConfigResponse interface.
 */
export function instanceOfUpdateReportConfigResponse(value: object): value is UpdateReportConfigResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function UpdateReportConfigResponseFromJSON(json: any): UpdateReportConfigResponse {
    return UpdateReportConfigResponseFromJSONTyped(json, false);
}

export function UpdateReportConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReportConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function UpdateReportConfigResponseToJSON(json: any): UpdateReportConfigResponse {
    return UpdateReportConfigResponseToJSONTyped(json, false);
}

export function UpdateReportConfigResponseToJSONTyped(value?: UpdateReportConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

